<template>
    <v-app-bar color="white elevation-2" app fixed clipped-left extended extension-height="0">
        <v-app-bar-nav-icon v-if="loggedIn" @click="toggleDrawer" />
        <router-link :to="{ name: 'dashboard' }" class="d-flex ml-3">
            <img src="@/assets/colours-factory-logo.svg" class="logo" alt="logo CF" />
        </router-link>
        <v-chip v-if="environmentBadgeEnv" class="ml-2 text-uppercase" color="secondary" variant="flat" size="small">
            {{ $t('common.components.toolbar.environmentBadge', { env: environmentBadgeEnv }) }}
        </v-chip>
        <v-spacer />
        <span v-if="loggedIn" class="mr-3 hidden-xs-only">
            {{ $t('common.components.toolbar.welcomeMessage') }}, {{ userName }}!
        </span>
        <v-menu v-if="loggedIn" bottom left>
            <template #activator="{ props }">
                <v-btn dark icon class="elevation-0 bg-secondary" size="small" v-bind="props">
                    <v-icon color="white"> mdi-account </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-list subheader>
                    <v-list-item>
                        <template #prepend>
                            <v-avatar dark color="secondary" size="32px">
                                <v-icon color="white"> mdi-account </v-icon>
                            </v-avatar>
                        </template>
                        <v-list-item-title>
                            {{ $t('common.components.toolbar.welcomeMessage') }}, {{ userName }}!
                        </v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-divider />
                <v-list>
                    <v-list-subheader>Konto</v-list-subheader>
                    <v-list-item @click="openChangePasswordDialog">
                        <v-list-item-title>Zmiana hasła</v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-divider />

                <v-list>
                    <v-list-item @click="logout">
                        <v-list-item-title>Wyloguj</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <template #extension>
            <v-progress-linear
                absolute
                :active="mainLoader"
                indeterminate
                class="ma-0"
                :height="4"
                style="top: -2px"
                color="info"
            />
        </template>
    </v-app-bar>
</template>

<script setup>
/*
    Organization / ordering applied:
    1. Imports
    2. Props / Emits
    3. Constants
    4. Stores & top-level services
    5. Reactive state (refs/reactive)
    6. Validation rules & setup
    7. Computed
    8. Handlers / methods
    9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { useUserStore } from '@/stores'

// 2. Props / Emits
const props = defineProps({
    drawer: {
        type: Boolean
    },
    mainLoader: {
        type: Boolean
    }
})
const emit = defineEmits(['toggleDrawer', 'open-change-password-dialog'])

// 3. Constants
// none

// 4. Stores & top-level services
const router = useRouter()
const userStore = useUserStore()

// 5. Reactive state (refs/reactive)
// none

// 6. Validation rules & setup
// none

// 7. Computed
const loggedIn = computed(() => {
    return userStore.loggedIn
})
const userName = computed(() => {
    return userStore.userName
})
const environmentBadgeEnv = computed(() => {
    const mode = import.meta.env.VITE_APP_MODE

    if (mode === 'stage') {
        return 'stage'
    }

    if (mode === 'development') {
        return 'dev'
    }

    return null
})

// 8. Handlers / methods
function toggleDrawer() {
    emit('toggleDrawer', !props.drawer)
}
function openChangePasswordDialog() {
    emit('open-change-password-dialog')
}
function logout() {
    userStore.logout()
    router.replace({ name: 'userLogin' })
}

// 9. Helpers / lifecycle
// none
</script>
